import { applySimilarVariantFilter as applySimilarVariantFilterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { openProgressModal } from '@process-advisor/process-miner/api/methods/modals/openProgressModal';
import { closeProgressModal } from '@process-advisor/process-miner/api/methods/modals/closeProgressModal';

export type Props = ApiMethodBase & {
    variantID?: string,
    filterType?: string
}

export async function  applySimilarVariantFilter ({ variantID,filterType,eventEmitter}: Props) {
    const sleep = ms => new Promise(r => setTimeout(r, ms));
    openProgressModal({status: 'Applying Variant Filter'})
    await sleep(200) // needed to display Progress
    await applySimilarVariantFilterDiagram({variantID: variantID,filterType:filterType},'',false);
    closeProgressModal()
    eventEmitter.emit(Event.applyFilter);
    apiProvider.setDiagramVisualizer()    
    eventEmitter.emit(Event.updateGaugeMetrics);
};

